import * as React from 'react';

export interface PodcastFeedDataContext {
  podcastId: string;
}

export default React.createContext<PodcastFeedDataContext>({
  podcastId: undefined,
});
